<script>
import AiWidgetSegment from '../ai_widget/ai_widget_segment.vue';

export default {
  name: 'DecisionLogInlineRow',
  components: {
    AiWidgetSegment,
  },
};
</script>

<template>
  <ai-widget-segment
    :label="s__('WorkItemDecisionLog|Decision log')"
    data-testid="decision-log-inline-row"
  >
    <span class="gl-text-subtle" data-testid="decision-log-status">
      {{ s__('WorkItemDecisionLog|No decisions yet') }}
    </span>
  </ai-widget-segment>
</template>
